import React, { useEffect } from 'react';

const Privacy = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <section className="py-32 bg-white">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <h1 className="text-4xl font-bold text-secondary mb-10 text-center">Política de Privacidad</h1>

                <div className="prose prose-lg mx-auto">
                    <h2 className="text-2xl font-semibold text-secondary mt-8 mb-4">1. Introducción</h2>
                    <p className="text-gray-700 mb-4">
                        En Grovi, respetamos su privacidad y nos comprometemos a proteger sus datos personales.
                        Esta política de privacidad le informará sobre cómo cuidamos sus datos personales cuando
                        visita nuestro sitio web y le informará sobre sus derechos de privacidad y cómo la ley lo protege.
                    </p>

                    <h2 className="text-2xl font-semibold text-secondary mt-8 mb-4">2. Datos que Recopilamos</h2>
                    <p className="text-gray-700 mb-4">
                        Podemos recopilar, utilizar, almacenar y transferir diferentes tipos de datos personales sobre usted, que hemos agrupado de la siguiente manera:
                    </p>
                    <ul className="list-disc pl-6 mb-6 text-gray-700">
                        <li className="mb-2">Datos de identidad: nombre, apellido</li>
                        <li className="mb-2">Datos de contacto: dirección de correo electrónico, número de teléfono</li>
                        <li className="mb-2">Datos técnicos: dirección IP, tipo y versión del navegador, configuración de zona horaria y ubicación</li>
                        <li className="mb-2">Datos de uso: información sobre cómo utiliza nuestro sitio web</li>
                    </ul>

                    <h2 className="text-2xl font-semibold text-secondary mt-8 mb-4">3. Cómo Utilizamos sus Datos</h2>
                    <p className="text-gray-700 mb-4">
                        Utilizaremos sus datos personales solo cuando la ley nos lo permita. Más comúnmente, utilizaremos sus datos personales en las siguientes circunstancias:
                    </p>
                    <ul className="list-disc pl-6 mb-6 text-gray-700">
                        <li className="mb-2">Para registrar su cuenta y gestionar nuestra relación con usted</li>
                        <li className="mb-2">Para procesar y entregar nuestros servicios</li>
                        <li className="mb-2">Para mejorar nuestro sitio web, productos y servicios</li>
                        <li className="mb-2">Para recomendarle productos o servicios que puedan interesarle</li>
                    </ul>

                    <h2 className="text-2xl font-semibold text-secondary mt-8 mb-4">4. Divulgación de sus Datos</h2>
                    <p className="text-gray-700 mb-4">
                        Podemos compartir sus datos personales con las partes que se indican a continuación:
                    </p>
                    <ul className="list-disc pl-6 mb-6 text-gray-700">
                        <li className="mb-2">Proveedores de servicios que proporcionan servicios de TI y administración de sistemas</li>
                        <li className="mb-2">Asesores profesionales que incluyen abogados, banqueros, auditores y aseguradoras</li>
                        <li className="mb-2">Las autoridades fiscales, reguladoras y otras autoridades</li>
                    </ul>

                    <h2 className="text-2xl font-semibold text-secondary mt-8 mb-4">5. Seguridad de los Datos</h2>
                    <p className="text-gray-700 mb-4">
                        Hemos implementado medidas de seguridad apropiadas para evitar que sus datos personales se pierdan,
                        utilicen o accedan accidentalmente de manera no autorizada, se modifiquen o divulguen.
                    </p>

                    <h2 className="text-2xl font-semibold text-secondary mt-8 mb-4">6. Sus Derechos Legales</h2>
                    <p className="text-gray-700 mb-4">
                        En determinadas circunstancias, tiene derechos en virtud de las leyes de protección de datos en relación con sus datos personales, que incluyen:
                    </p>
                    <ul className="list-disc pl-6 mb-6 text-gray-700">
                        <li className="mb-2">Solicitar acceso a sus datos personales</li>
                        <li className="mb-2">Solicitar la corrección de sus datos personales</li>
                        <li className="mb-2">Solicitar la eliminación de sus datos personales</li>
                        <li className="mb-2">Oponerse al procesamiento de sus datos personales</li>
                        <li className="mb-2">Solicitar la restricción del procesamiento de sus datos personales</li>
                        <li className="mb-2">Solicitar la transferencia de sus datos personales</li>
                    </ul>

                    <h2 className="text-2xl font-semibold text-secondary mt-8 mb-4">7. Contacto</h2>
                    <p className="text-gray-700 mb-4">
                        Si tiene alguna pregunta sobre esta política de privacidad o nuestras prácticas de privacidad,
                        contáctenos a través de:
                    </p>
                    <p className="text-gray-700 mb-4">
                        <strong>Email:</strong> hola@grovi.com.uy
                    </p>
                </div>

                <div className="mt-12 text-center">
                    <a href="/" className="inline-flex items-center px-6 py-3 bg-primary text-white font-medium rounded-lg hover:bg-primary-dark transition-all duration-300">
                        <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
                        </svg>
                        Volver al Inicio
                    </a>
                </div>
            </div>
        </section>
    );
};

export default Privacy; 